import React, { useState } from 'react';
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../../../providers/Layout.provider';
import PaymentMethodForm from './PaymentMethodForm';
import styles from './PaymentMethod.module.scss';
import { usePaylink } from '../../../../../providers/Paylink.provider';

export type PaymentMethodProps = {
  paymentMethodKey: string;
  isOpen: boolean;
  Header: React.JSX.Element;
  onRemove?: () => void;
  onUpdate?: (amount: string) => void;
  onClick: () => void;
  account?: React.JSX.Element | string;
  amountRemaining?: number;
  amount?: number;
};
const { Box, Icon, Button } = vp;
const PaymentMethod: React.FC<PaymentMethodProps> = ({
  isOpen,
  Header,
  onRemove,
  onUpdate,
  account,
  amountRemaining,
  amount,
  paymentMethodKey,
  onClick,
}: PaymentMethodProps) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const { color } = useLayout();
  const { paylink } = usePaylink();
  const { t } = useTranslation('translations', { keyPrefix: 'MultiplePaymentMethods' });
  return (
    <div
      onClick={() => {
        if (!isOpen) {
          onClick();
        }
      }}
      onKeyDown={() => {}}
      className={styles.containerPayment}
      style={{
        cursor: !isOpen ? 'pointer' : 'default',
      }}
      role="button"
      tabIndex={0}
    >
      <Box
        base="8"
        pt={isOpen ? 'lmd' : 'md'}
        pb={isOpen ? 'lmd' : 'md'}
        pe="smd"
        ps="smd"
        gap="lmd"
        flx="col"
        boundary="shadow"
        r="sm"
        maxwidth="100%"
      >
        <Box flx="row" jc="sb" ai="center">
          <span className={styles.containerPaymentBold}>{Header}</span>
          {!isOpen && <Icon icon={isOpen ? 'angleTop' : 'angleRight'} height="14px" width="14px" />}
        </Box>
        {isOpen && (
          <div className={styles.containerItem}>
            <Box base="8" gap="lmd" flx="col">
              <Box flx="row" jc="sb" ai="center">
                <div className={styles.containerPaymentBold}>{account}</div>

                <Box flx="row" jc="sb" gapSize="10px" ai="center">
                  {!isUpdating && (
                    <span className={styles.containerPaymentBold}>
                      {paylink?.Currency} {vp.formattedCurrency(vp.sanitizeToNumeric(amount?.toString()) || '')}
                    </span>
                  )}
                  {!isUpdating && (
                    <Button
                      label=""
                      id={`${paymentMethodKey}-edit`}
                      color="primary"
                      icon="edit"
                      iconLocation="center"
                      round
                      iconColor={vp.getLuminance(color) > 0.5 ? 'primary-dark' : 'primary-light'}
                      iconHeight="9px"
                      iconWidth="9px"
                      height="21px"
                      width="21px"
                      borderRadius="50%"
                      noPadding
                      background={color}
                      textColor={vp.getContrastColor(color)}
                      onClick={() => {
                        setIsUpdating(true);
                      }}
                    />
                  )}
                  {isUpdating && (
                    <Button
                      label={
                        <Box ps="sm" base="8" ai="center">
                          {`${t('remove')}`}
                        </Box>
                      }
                      id={`${paymentMethodKey}-edit`}
                      color="secondary"
                      iconHeight="11px"
                      iconWidth="11px"
                      height="32px"
                      iconLocation="left"
                      icon="trash"
                      round
                      noShadow
                      onClick={() => {
                        if (onRemove) onRemove();
                      }}
                    />
                  )}
                </Box>
              </Box>
              {isUpdating && (
                <PaymentMethodForm
                  defaultValues={{
                    Amount: amount?.toString() || '',
                    MaximumAmount: ((amountRemaining || 0) + (amount || 0))?.toString() || '',
                  }}
                  onSave={(_values) => {
                    setIsUpdating(false);
                    if (onUpdate) onUpdate(_values.Amount);
                  }}
                  onCancel={() => {
                    setIsUpdating(false);
                  }}
                />
              )}
            </Box>
          </div>
        )}
      </Box>
    </div>
  );
};

export default PaymentMethod;
